import Types from 'constants/types';

// Load labels from field tree into a map where predicate -> value
export const loadLabels = tabs => {
  const labels = {};

  for (let field of getObjectFields(tabs)) {
    const { predicate } = field;
    labels[predicate] = field.label;
  }

  return labels;
};

// For easier array access to all fields
export const getObjectFields = tabs => {
  const fields = [];

  tabs.forEach(tab => {
    tab.groups.forEach(group => {
      group.fields.forEach(field => {
        // converts empty values to false
        // -> submitted on save
        if (field.type === Types.XSD.BOOLEAN) {
          field.values[0] = field.values[0] === true;
        }
        fields.push(field);
      });
    });
  });
  return fields;
};

// Load fields with updated values for validation
export const insertValuesToFields = (originalFields, values) => {
  const fields = [];

  originalFields.forEach(field => {
    fields.push({...field, values: values[field.predicate]});
  });

  return fields;
};

// value to React-Select format (Enum)
export const valueToOption = value => {
  if (!value) {
    return '';
  }
  
  return {
    value: value.uri,
    label: value.display
  };
};

// React-Select format to value
export const optionToValue = option => {
  return {
    uri: option.value,
    display: option.label
  };
};

export const mapObjectFields = (object, mappingFunction) => {
  object.tabs.forEach(tab => {
    tab.groups.forEach(group => {
      group.fields.forEach(field => {
        mappingFunction(field);
      });
    });
  });

  return object;
};

export const getResourceFields = (value) => {
  const fields = value.fields;
  
  if (Array.isArray(fields)) {
    return fields;
  }
  else if (isObject(fields)) {
    // Override labels option, Resource returned as map
    return Object.values(fields);
  }
  // legacy support, data should have value.fields
  else if (isObject(value)) {
    return Object.values(value);
  }
  else {
    return null;
  }
};

export const isObject = value => value != null && typeof value === 'object';

// Mass edit / metadata template do not have minOccurs requirements
export const disableMinOccurs = object => mapObjectFields(object, f => f.props.minOccurs = 0);

/**
 * 
 * @param {*} fields
 * @returns boolean - checks whether all mandatory fields have a non-empty value 
 */
export const isSaveDisabled = (fields) => {
  if (!fields) {
    return false;
  }
  return Object.values(fields).filter(field => field?.props?.minOccurs > 0 && valuesIsEmpty(field?.values))?.length !== 0;
};

/**
 * 
 * @param {*} values 
 * @returns boolean - checks whether field has a non-empty value (either an object or an primitive)
 */
const valuesIsEmpty = (values) => {
  // values.length === 0
  if (!values || values.length === 0) {
    return true;
  } 
  // return false for booleans as they always have some value so they are never empty
  if (values.length === 1 && (typeof values[0] == "boolean") ) {
    return false;
  } 

  // values.length > 1 or values.length === 1 but value is primitive
  if (values.length === 1 && !isObject(values[0])) {
    return values[0].trim() === '';
  } else if (values.length > 1) {
    return false;
  }
  // values contains non-primitives
  return values.filter(obj => obj !== '')
    .map(obj => obj.display)
    .filter(disp => Array.isArray(disp)
      ? disp.length > 0
      : isObject(disp) || (disp.length > 0 && disp.trim().length > 0)
    )?.length === 0;
};